import { Box, Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * The properties for the header
 */
interface HeaderProps {
  /**
   * The title for the header
   */
  title: string;
  /**
   * The subtitle for the header
   */
  subtitle: string;
  /**
   * Swap the html components for the title, making the title the <h2> and the subtitle <h1>
   */
  useTitleH2?: boolean;
}

/**
 * The header that's used within the articles view
 */
const Header = ({ title, subtitle, useTitleH2 = true }: HeaderProps) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        '@keyframes animatedBackground': {
          '0%': {
            backgroundPosition: '0% 50%',
          },
          '50%': {
            backgroundPosition: '100% 50%',
          },
          '100%': {
            backgroundPosition: '0% 50%',
          },
        },
        background:
          'linear-gradient(-70deg, #c2185b, #512da8, #1976d2, #0097a7)',
        backgroundSize: '400% 400%',
        animation: 'animatedBackground 10s ease infinite',
      }}
    >
      <Box marginTop="3em" marginBottom="2em">
        <Container maxWidth="md">
          <Typography
            id="article-header"
            color="white"
            variant="h2"
            component={useTitleH2 ? 'h2' : 'h1'}
            textAlign="center"
            sx={{
              fontWeight: 700,
            }}
          >
            {title}
          </Typography>
        </Container>
        <Typography
          id="article-second-header"
          component={useTitleH2 ? 'h1' : 'h2'}
          textAlign="center"
          sx={{
            fontWeight: 'medium',
            fontSize: '1.2em',
          }}
          gutterBottom
          color="white"
        >
          {subtitle}
        </Typography>
      </Box>
      <Box
        bgcolor="transparent"
        component={'svg'}
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1920 100.1"
        sx={{
          width: '100%',
          marginBottom: '-2px',
        }}
      >
        <path
          fill={theme.palette.background.default}
          d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
        ></path>
      </Box>
    </Box>
  );
};

export default Header;
